'use client';

const LEGACY_REGISTRATION_KEY = 'registration';

export const removeLegacyRegistrationStorage = () => {
  try {
    localStorage.removeItem(LEGACY_REGISTRATION_KEY);
  } catch {
    return;
  }
};
